import React from 'react';
import { Skeleton, Grid, Typography } from '@mui/material';

export const WarrantyDisplayShimmer: React.FC = () => {
    return (
        <div style={{ padding: '10px', border: '1px solid #ddd', marginTop: '10px', borderRadius: '4px', backgroundColor: '#fafafa', borderColor: '#e74c3c', maxWidth: 'fit-content' }}>
            <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap">
                <Grid item xs>
                    <Typography variant="body2">
                        <Skeleton width={200} />
                    </Typography>
                    <Typography variant="body2">
                        <Skeleton width={100} />
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
};